import './checkBox.scss';

export default function CheckBox({
  name,
  value,
  etiqueta,
  onChange,
  checked = false,
  disabled = false,
}) {
  return (
    <div className='checkBox_container '>
      <input
        className='checkBox'
        type='checkBox'
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        id={`checkbox_${value}_id`}
      />{' '}
      <label htmlFor={`checkbox_${value}_id`} className='checkBox_label'>
        {etiqueta}
      </label>
    </div>
  );
}
